//import { configure } from "@testing-library/react";
import axios from "axios";
import TokenService from "./token.service";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  async (config) => {
    let token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = 'Bearer ' + token;  
      config.headers["Accept"] = "application/json;odata=verbose";
    } else {
        token = await getauthToken(); 
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== "/CRPublic" && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await axios.get(process.env.REACT_APP_API_ENDPOINT + "/Token", {headers:{
            "Accept": "text/html;text/plain;application/xhtml+xml,application/xml", 
            "Access-Control-Request-Private-Network": true}});
        
         //  console.log(rs.data); 
          TokenService.updateLocalAccessToken(rs.data);
          
          let config = originalConfig; 
          config.headers["Authorization"] = 'Bearer ' + rs.data;  
          return instance(config);
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

let getauthToken = async () => {
    const response = await axios.get(process.env.REACT_APP_API_ENDPOINT + "/Token", {headers:{
        "Accept": "text/html;text/plain;application/xhtml+xml,application/xml", 
        "Access-Control-Request-Private-Network": true}});

        
    TokenService.updateLocalAccessToken(response.data);
    return response.data;

  }

          

export default instance;

 